import { Texts } from './Reusables/Utility';

export interface LimitOption {
    value: string;
    label: string;
}

export const limitOptions: LimitOption[] = [
    //{ value: "hourly", label: "Hourly" },
    { value: "daily", label: "Daily" },
    { value: "weekly", label: "Weekly" },
    { value: "monthly", label: "Monthly" },
    { value: "yearly", label: "Yearly" },
];

export const formatLimit = (
    amount: string | number,
    locale: string = "en-US",
    currency: string = "USD",
    symbol: string = "$"
): string => {
    if (currency === null) currency = Texts.USD;
    if (symbol === null) symbol = Texts.SymbolDollar;
    const numericAmount = parseFloat(String(amount).replace(/,/g, ""));
    if (isNaN(numericAmount)) return "";

    return `${symbol} ${new Intl.NumberFormat(locale, {
        style: "currency",
        currency: currency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).format(numericAmount).replace(/[^\d.,-]/g, "")}`;
};

export const convertToNumber = (value: string | number): number => {
    if (typeof value === "number") return value;
    if (!value) return 0;
    return parseFloat(value.replace(/,/g, "")) || 0;
};